var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('h1',{staticClass:"text-center"},[_vm._v("Redirecting to legacy application.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }